import type { FlagRecord } from "../../../lib";
import type { UseRequestMutationProps } from "../../../request";
import { useRequestMutation } from "../../../request";

export type UseRequestFlagRecordProps = UseRequestMutationProps<
  any,
  FlagRecord
>;

export const useRequestFlagRecord = ({
  ...props
}: UseRequestFlagRecordProps = {}) => ({
  mutationPost: useRequestMutation({
    ...props,
    mutationFnRequestProps: (data: FlagRecord) => ({
      body: JSON.stringify(data),
      urlBackendPath: "/moderation/flag-record",
    }),
  }),
});
